import * as React from "react";
import { Navigate } from "react-router";
import { isMobileBuild } from "./index";

interface Props {
  children: React.ReactNode;
  /** Where to redirect on mobile builds. Defaults to "/" */
  fallback?: string;
}

/**
 * Runtime safety net for admin/ml routes on mobile builds.
 * The first wall is Rollup tree-shaking via __MOBILE_BUILD__ in vite.config.ts.
 * This component is the second wall — catches direct URL navigation on device.
 */
export function MobileGuard({
  children,
  fallback = "/",
}: Props): React.ReactElement {
  if (isMobileBuild) {
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
}
